import magnificPopup from 'magnific-popup';

let lightboxClass = $('.lightbox');

if( lightboxClass.length > 0 ) {

    lightboxClass.magnificPopup({
        type: 'iframe'
    });

}
